import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type GpAwarenessPill from './index.tsx';
import type { GpAwarenessPillProps } from './types.tsx';

const LazyGPAwarenessPill = lazyForPaint<typeof GpAwarenessPill>(
	() => import(/* webpackChunkName: "async-gp-awareness-pill" */ './index.tsx'),
	{ entryFsSsrOverride: 'exclude' },
);

export const AsyncGPAwarenessPill = (props: GpAwarenessPillProps): React.JSX.Element => (
	<Placeholder name="horizontal-project-nav" fallback={null}>
		<LazyGPAwarenessPill {...props} />
	</Placeholder>
);
